import fetchServer from "../fetchServer";

export default async function approvePriceFreeze(data) {
  let result = {
    return: 0,
    msg: "Failed to approve price freeze",
  };

  await fetchServer({
    method: "POST",
    url: "/payment/v1/payment/price-freeze/approval",
    data,
  })
    .then((res) => {
      // Success: axios response with status 200/201
      // Error: fetchServer returns err.response.data (no status)
      if (res?.status === 200 || res?.status === 201) {
        result = {
          return: 1,
          msg: res?.data?.message || "Price freeze approved successfully",
          data: res?.data?.data,
        };
        return;
      }

      result.msg =
        res?.data?.error ||
        res?.error ||
        res?.data?.message ||
        res?.message ||
        result.msg;

      if (typeof result.msg !== "string") {
        result.msg =
          result.msg?.message ||
          result.msg?.error ||
          "Failed to approve price freeze";
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result.msg = "Network Error!";
      } else if (err?.message) {
        result.msg = err.message;
      }
    });

  return result;
}
